export default __webpack_public_path__ + "static/media/right-bottom.8ddec76d.gif";